let AppleLoginBtn
if (process?.env?.REACT_APP_CORDOVA) {
  AppleLoginBtn = require('./AppleLoginBtn.cordova.js').default
} else {
  AppleLoginBtn = require('./AppleLoginBtn.js').default
}
export default AppleLoginBtn